/* eslint-disable no-unused-vars */
import { TResursTreeNode } from '../treeTypes';
import { getOperatorListByRole, getUserListByRole } from './create-list';

export const handelAddUser = (
  _treeName: string,
  node: TResursTreeNode,
  role: string,
  setShowCreateModal: (arg: boolean) => void,
  setTreeObjectListAvailableToAdd: (arg: any) => void
) => {
  if (_treeName === 'user') {
    const userListAbstract = getUserListByRole(role);
    const userListByNode = node
      ? userListAbstract[node.className]
      : userListAbstract['root'];
    const params = {
      list: userListByNode,
      listCaption: 'Тип абонента:',
    };
    if (params && params.list && params.list.length > 0) {
      setTreeObjectListAvailableToAdd(params);
      setShowCreateModal(true);
    }
  }
  if (_treeName === 'operator') {
    const operatorListAbstract = getOperatorListByRole(role);
    const params = {
      list: operatorListAbstract,
      listCaption: 'Тип оператора:',
    };
    if (params.list.length > 0) {
      setTreeObjectListAvailableToAdd(params);
      setShowCreateModal(true);
    }
  }
};
